import { Model } from '@vuex-orm/core';

export default class Imageable extends Model {
  static entity = 'imageables';

  static fields() {
    return {
      id: this.uid(),
      image_id: this.attr(null),
      imageable_id: this.attr(null),
      imageable_type: this.attr(null),
    };
  }
}
